var render, staticRenderFns
import script from "./ReplyItem.vue?vue&type=script&lang=tsx&"
export * from "./ReplyItem.vue?vue&type=script&lang=tsx&"
import style0 from "./ReplyItem.vue?vue&type=style&index=0&id=dd98cf60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd98cf60",
  null
  
)

export default component.exports